"use client";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "../../Styles/ContentHeader.css"; // 스타일 파일 import
import User_icon from "../../Styles/icons/User_icon.png";
import { useLocation, useNavigate, Link } from "react-router-dom";
import logo from "../../Styles/image/logo.png"; // Import the logo image
import LogoutButton from "../Auth/LogoutButton";
import axios from "../../lib/http/axiosConfig";
import MobileHeaderRefreshButton from "./MobileHeaderRefreshButton";
import { SUPPORTED_LANGS, useLang, useT } from "../../i18n";

function Header({ onMenuicon, isMenuActive }) {
  // const [isDarkMode, setIsDarkMode] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [nickname, setNickname] = useState(
    localStorage.getItem("nickname") || "",
  );
  const [role, setRole] = useState(localStorage.getItem("role") || "");
  const t = useT();
  const [lang, setLang] = useLang();

  // const handleThemeToggle = () => {
  //   setIsDarkMode((prev) => !prev);
  // };

  // 미션 수행 중(시작~복귀)에는 사이드바 탭 잠금과 동일하게 사용자 메뉴 진입도 막는다.
  // 드론이 착륙(disarm)해 missionStatus/missionReturning이 풀릴 때까지 잠금.
  const missionStatus = useSelector(
    (state) => state.drone.control?.missionStatus
  );
  const missionReturning = useSelector((state) => state.drone.missionReturning);
  const navLocked = Boolean(missionStatus || missionReturning);

  const handleUserIconClick = () => {
    if (navLocked) {
      toast.warn(t("common.nav.lockedDuringMission"), {
        toastId: "nav-locked-during-mission",
      });
      return;
    }
    setIsUserMenuOpen((prev) => !prev);
  };

  const isAdmin = role && role.toUpperCase() === "ADMIN";

  const renderLangSwitch = (variant) => (
    <div
      className={`lang-switch ${variant}`}
      role="radiogroup"
      aria-label={t("common.header.langSwitch")}
    >
      {SUPPORTED_LANGS.map((code) => (
        <button
          key={code}
          type="button"
          role="radio"
          aria-checked={lang === code}
          className={`lang-switch__btn${lang === code ? " is-active" : ""}`}
          onClick={() => setLang(code)}
        >
          {t(`common.header.lang.${code}`)}
        </button>
      ))}
    </div>
  );

  const handleClickOutside = (e) => {
    if (!e.target.closest(".user-menu-container")) {
      setIsUserMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let mounted = true;

    const syncUserProfile = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        if (!mounted) return;
        setNickname("");
        setRole("");
        localStorage.removeItem("nickname");
        return;
      }

      try {
        const { data } = await axios.get("/api/users/me");
        const profile = data?.data;
        if (!mounted || !profile) return;

        const nextNickname =
          (typeof profile.nickname === "string" && profile.nickname.trim()) ||
          (typeof profile.username === "string" && profile.username.trim()) ||
          "";
        const nextRole =
          (typeof profile.role === "string" && profile.role.trim()) ||
          localStorage.getItem("role") ||
          "";

        setNickname(nextNickname);
        setRole(nextRole);

        if (nextNickname) localStorage.setItem("nickname", nextNickname);
        else localStorage.removeItem("nickname");
        if (nextRole) localStorage.setItem("role", nextRole);
      } catch (error) {
        if (!mounted) return;
        setNickname(localStorage.getItem("nickname") || "");
        setRole(localStorage.getItem("role") || "");
      }
    };

    syncUserProfile();

    return () => {
      mounted = false;
    };
  }, [pathname]);

  return (
    <header className="content-header header">
      <MobileHeaderRefreshButton />
      <div className="header-logo-wrap">
        {/* <Link to="/"> */}
        <img src={logo} className="logo-image" alt="logo" />
        {/* </Link> */}
        <span className="app-version">{t("common.header.version", { version: "1.0" })}</span>
      </div>

      {/*  <nav className="nav-container">
        <NavigationItem
          icon="https://cdn.builder.io/api/v1/image/assets/d5cf95161d744fc3b5e58c7918fa0a7d/8833b02b7da8c4b8f0330a3f6c5e09e8366900aa966d3cfa33459ac02e9dd2a3?placeholderIfAbsent=true"
          text="Smart Pole"
          isSubItem={true}
          isActive={pathname === "/clebinepage"}
          href="/clebinepage"
        />
        <NavigationItem
          icon="https://cdn.builder.io/api/v1/image/assets/d5cf95161d744fc3b5e58c7918fa0a7d/418f52eb4aa429c212b299647587cf5713ea65dce2e99722445666f82a3d0170?placeholderIfAbsent=true"
          text="Smart Drone"
          isSubItem={true}
          isActive={pathname === "/smartdronepage"}
          href="/smartdronepage"
        />
         <NavigationItem
          icon="https://cdn.builder.io/api/v1/image/assets/d5cf95161d744fc3b5e58c7918fa0a7d/5c60b14f457afaecab9a29f52c3d61415eb723dc629c6f423794afffc6c039b4?placeholderIfAbsent=true"
          text="Smart Farm"
          isSubItem={true}
          isActive={pathname === "/Managementpage"}
          href="/Managementpage"
        />
      </nav>*/}

      <nav className="nav-header">
        {/* <div className="nav-group">
          <img src={Setting_icon} className="config-icon setting-icon" alt="Setting_icon" />
        </div> */}
        {/* 한/영 전환. 관리자·로그인·개인정보 페이지는 기존 문구 그대로라 여기서만 바꿔도 된다.
            모바일(≤900px)에서는 우상단 농장 드롭다운과 겹쳐서 계정 메뉴 안으로 옮긴다(CSS 로 전환). */}
        {renderLangSwitch("lang-switch--header")}
        <div className="nav-group user-menu-container">
          <div className="user-menu-trigger">
            {nickname && (
              <span className="user-nickname" title={nickname}>
                {nickname}
              </span>
            )}
            <img
              src={User_icon}
              className={`config-icon user-menu-icon${
                navLocked ? " is-locked" : ""
              }`}
              alt="User_icon"
              onClick={handleUserIconClick}
              role="button"
              tabIndex={0}
              aria-expanded={isUserMenuOpen}
              aria-disabled={navLocked || undefined}
              aria-label={t("common.header.userMenu")}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleUserIconClick();
                }
              }}
            />
          </div>
          {isUserMenuOpen && (
            <div className="user-dropdown-menu">
              <div className="user-menu-item user-menu-item--lang">
                <span>{t("common.header.langSwitch")}</span>
                {renderLangSwitch("lang-switch--menu")}
              </div>
              {/* <div className="user-menu-item">
                <span>프로필</span>
              </div>
              <div className="user-menu-item">
                <span>설정</span>
              </div> */}
              {/* <div className="user-menu-divider"></div> */}
              {isAdmin && (
                <div
                  className="user-menu-item"
                  onClick={() => navigate("/admin")}
                  style={{ cursor: "pointer" }}
                >
                  {t("common.header.adminPage")}
                </div>
              )}
              <div className="user-menu-item">
                <LogoutButton />
              </div>
            </div>
          )}
        </div>

        {/* <div className="nav-group">
          <img
            src={Menu_icon}
            className={`config-icon menu-icon ${isMenuActive ? "active" : ""}`}
            alt="Menu icon"
            onClick={() => onMenuicon}
          />
        </div> */}
      </nav>
    </header>
  );
}

export default Header;
